module.exports = __webpack_public_path__ + "static/media/map-marker.284d1ea8.svg";